import { __awaiter, __generator } from "tslib";
export function loadTriblio(analytics) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var account;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!window.Triblio) {
                        return [2 /*return*/];
                    }
                    if ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website) {
                        return [2 /*return*/];
                    }
                    account = window.Triblio.getAccountIdentification();
                    if (account.isIsp || !account.domain) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, analytics.group(null, {
                            website: account.domain,
                            intentSource: 'triblio',
                            name: account.name || undefined,
                            country: account.country || undefined,
                            industry: account.industry || undefined,
                            number_of_employees: account.employees || undefined,
                            annual_revenue: account.revenue || undefined,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=triblio.js.map